import React, {useEffect, useState} from 'react'

import {Col, Container, Row} from 'react-bootstrap'
import {useNavigate} from 'react-router-dom'

import KurzyLayout from './KurzyLayout'
import amaniPointing from '../assets/amani-thumbup.png'
import {useContentWrapper} from '../common/ContentWrapperProvider'
import {money} from '../common/helpers'
import {StyledInfoPageHeaderWrapper} from '../common/styledComponents'
import axios from '../service/axiosClient'
import {OrderItemCategory} from '../types/OrderItemCategory'
import {OrderItemDto, OrderItemDtoUI} from '../types/OrderItemDto'


function KurzyKurzyPage() {
    const contentWrapper = useContentWrapper()
    const [products, setProducts] = useState<OrderItemDtoUI[]>([])
    const [expandedItems, setExpandedItems] = useState<Set<number>>(new Set())
    const navigate = useNavigate()

    useEffect(() => {
        contentWrapper.setNoBootstrapColumns(true)

        axios.get('/order-item/' + OrderItemCategory.KURZY, {}).then(response => {
            const tmpMaterialy = response.data

            if (tmpMaterialy.length === 0) {
                tmpMaterialy.push({isFake: true}, {isFake: true}, {isFake: true})
            } else if (tmpMaterialy.length === 1) {
                tmpMaterialy.push({isFake: true}, {isFake: true})
            } else if (tmpMaterialy.length === 2) {
                tmpMaterialy.push({isFake: true})
            }

            console.log(tmpMaterialy)

            setProducts(tmpMaterialy)
        }).catch(error => {
            console.log('error', error)
        })

        return () => {
            contentWrapper.setNoBootstrapColumns(false)
        }
    }, [])

    const handleProductSelect = (item: OrderItemDto) => {
        localStorage.setItem('selectedProduct', JSON.stringify(item))
        navigate('/kurzy-pokladna')
    }

    return (
        <KurzyLayout>
            <StyledInfoPageHeaderWrapper>
                <Container>
                    <Row>
                        <Col>
                            <h1 className={'font-vollkorn fs-55 color-pink-primary'}>Kurzy</h1>
                        </Col>
                    </Row>
                </Container>

            </StyledInfoPageHeaderWrapper>
            <Container>
                <Row>
                    <Col>
                        <div className="kurzy-container">
                            {products.map((item, index) => {
                                return <>{item.isFake ?
                                    <div></div> :
                                    <div key={item.id} className="rounded-content-body mt-3 text-pink-dark">
                                        <h3 className={'font-vollkorn color-pink-primary mb-2'}>{item.name}</h3>

                                        {expandedItems.has(item.id) ? (
                                            <>
                                                <div dangerouslySetInnerHTML={{__html: item.moreInfo || ''}}/>

                                                <div className={'d-flex justify-content-center mt-3'}>
                                                    <button
                                                        onClick={() => handleProductSelect(item)}
                                                        className="btn btn-primary bg-pink-dark pink-color btn-amani w-100 d-inline-block text-uppercase">
                                                        chcem kúpiť
                                                    </button>
                                                </div>
                                            </>
                                        ) : (
                                            <>
                                                <div dangerouslySetInnerHTML={{__html: item.description}}/>
                                                <br/><br/>
                                                <strong><span className={'font-vollkorn kurziva'}>Čo sa dozvieš:</span></strong>
                                                <div dangerouslySetInnerHTML={{__html: item.agenda}}/>
                                                <br/><br/>
                                                Dátum: <strong>{item.date}</strong><br/>
                                                Čas: {item.time}<br/>
                                                Miesto: {item.location}<br/>
                                                Cena: <strong>{item.price ? money.format(item.price) : 'bezplatne'}</strong>{item.installmentBuying && ' (možnosť úhrady na 3 splátky)'}<br/>
                                                Lektor: <strong>{item.lektor}</strong><br/>

                                                {item.moreInfo ? (
                                                    <div className={'d-flex justify-content-center mt-3'}>
                                                        <button
                                                            onClick={() => setExpandedItems(prev => new Set(prev).add(item.id))}
                                                            className="btn btn-primary bg-pink-dark pink-color btn-amani w-100 d-inline-block text-uppercase">
                                                            viac informácií
                                                        </button>
                                                    </div>
                                                ) : (
                                                    <div className={'d-flex justify-content-end mt-2'}>
                                                        <button
                                                            onClick={() => handleProductSelect(item)}
                                                            className="btn btn-primary bg-pink-dark pink-color btn-amani w-auto d-inline-block text-uppercase">
                                                            chcem kúpiť
                                                        </button>
                                                    </div>
                                                )}
                                            </>
                                        )}

                                    </div>}{index === 2 &&
                                    <div><img src={amaniPointing} alt="" className={'w100p'}/></div>
                                }</>
                            })}
                        </div>
                    </Col>
                </Row>
            </Container>
        </KurzyLayout>
    )
}


export default KurzyKurzyPage
